// Tokens de la maquette henri-trip-fiche-poi-maquette.html (thème clair figé).
const v3Theme = {
  colors: {
    paper: '#F3F6F9',
    paperCard: '#FFFFFF',
    paperSunk: '#E9EEF3',
    ink: '#1E222C',
    inkSoft: '#5B6270',
    inkFaint: '#868D9C',
    brand: '#54A8FC',
    brandInkOn: '#101319',
    brandText: '#1B6FC4',
    line: 'rgba(30,34,44,.12)',
    lineStrong: 'rgba(30,34,44,.20)',
    open: '#2E7D34',
    closed: '#A5342A',
    // alias v2 requis par LanguageSelector rendu sous le thème v3
    black: '#000000',
    white: '#FFFFFF',
    white60: '#FFFFFF99',
    lightGrey: '#D5D5D7',
  },
  shadow: '0 2px 6px rgba(30,34,44,.04), 0 16px 32px rgba(30,34,44,.08)',
  radius: '20px',
  font: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
  wrap: '1180px',
  gutter: 'clamp(20px, 5vw, 56px)',
};

export default v3Theme;
